/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { services } from '../../context';
import { StoresState } from './storesTypes';

const initialState: StoresState = {
  availableStores: [],
};

export const getStores = createAsyncThunk(
  'stores/getStores',
  async (
    {
      zipCode,
      serviceProductId,
    }: {
      zipCode: string;
      serviceProductId: string;
    },
    { rejectWithValue },
  ) => {
    const { result, error } = await services.appointment.getAvailableStores(
      zipCode,
      serviceProductId,
    );

    if (error) {
      return rejectWithValue(error);
    }

    return result.stores;
  },
);

const storesSlice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    clearAvailableStores(state) {
      state.availableStores = [];
    },
    updateStoresStateFromCache(state, action: PayloadAction<StoresState>) {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStores.fulfilled, (state, action) => {
      state.availableStores = action.payload;
    });
  },
});

export const { clearAvailableStores, updateStoresStateFromCache } =
  storesSlice.actions;

export default storesSlice.reducer;
